import React from "react";
import PageHeader from "../components/PageHeader";
import { TRAININGS } from "../data/mock";
import { Clock, MapPin, Award, ArrowRight, GraduationCap, Users, Video } from "lucide-react";
import { Link } from "react-router-dom";
import ContactCTA from "../components/ContactCTA";

const TrainingPage = () => (
  <>
    <PageHeader
      title="ISO Training & Certification Courses"
      subtitle="Awareness, internal auditor, lead auditor and lead implementer courses across every major ISO standard. Classroom, virtual and in-house delivery."
      crumbs={[{ label: "Training" }]}
    />

    <section className="section-pad bg-white">
      <div className="lis-container">
        <div className="grid md:grid-cols-3 gap-6 mb-12">
          {[
            { icon: GraduationCap, title: "IRCA / Exemplar Global Certified", text: "Internationally recognised lead auditor and lead implementer certificates." },
            { icon: Users, title: "In-house & Public Batches", text: "Choose from open public batches or dedicated in-company training programs." },
            { icon: Video, title: "Classroom & Virtual", text: "Live instructor-led sessions online or in-person, with hands-on exercises." },
          ].map((f) => (
            <div key={f.title} className="p-6 rounded-2xl border border-slate-100 card-hover">
              <div className="w-12 h-12 rounded-lg bg-red-50 text-brand flex items-center justify-center">
                <f.icon size={22} />
              </div>
              <h3 className="mt-4 font-semibold text-slate-900">{f.title}</h3>
              <p className="mt-2 text-sm text-slate-600">{f.text}</p>
            </div>
          ))}
        </div>

        <div className="max-w-2xl">
          <span className="eyebrow">Featured Courses</span>
          <h2 className="mt-3 text-3xl md:text-4xl font-bold text-slate-900">Upcoming and on-demand courses</h2>
          <div className="divider-red mt-4" />
        </div>

        <div className="mt-10 grid md:grid-cols-2 gap-5">
          {TRAININGS.map((t) => (
            <div key={t.title} className="p-6 rounded-2xl border border-slate-100 bg-white card-hover flex flex-col">
              <div className="flex items-center gap-2">
                <span className="chip">{t.level}</span>
                <span className="text-xs text-slate-500">{t.cert}</span>
              </div>
              <h3 className="mt-3 text-lg font-semibold text-slate-900">{t.title}</h3>
              <div className="mt-4 flex flex-wrap items-center gap-4 text-sm text-slate-600">
                <span className="flex items-center gap-1.5"><Clock size={14} className="text-brand" /> {t.days} day{t.days > 1 ? "s" : ""}</span>
                <span className="flex items-center gap-1.5"><MapPin size={14} className="text-brand" /> {t.mode}</span>
                <span className="flex items-center gap-1.5"><Award size={14} className="text-brand" /> {t.cert}</span>
              </div>
              <div className="mt-5 flex items-center justify-between">
                <div className="text-sm text-slate-500">Fees: <span className="font-semibold text-slate-900">{t.price}</span></div>
                <Link to="/contact" className="btn-brand text-sm">Enrol <ArrowRight size={14} /></Link>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>

    <ContactCTA />
  </>
);

export default TrainingPage;
